import { useState } from 'react';
import { FiArrowRight, FiCheck, FiClock, FiLoader } from 'react-icons/fi';
import { CommandDetails, RunResult } from './CommandCard';
import RecoveryResults from './RecoveryResults';

export default function RecoveryPanel({ command, result, running, showDetails, onRun }) {
    const [hours, setHours] = useState(48);
    const Icon = command.icon;
    const busy = running === command.id;
    return <section className="command-recovery" aria-labelledby="command-recovery-title" aria-busy={busy}>
        <header><span className="command-section-eyebrow">PAYMENT RECOVERY</span><span className="command-card-icon command-tone-amber"><Icon aria-hidden="true" /></span>
            <h2 id="command-recovery-title">{command.title}</h2><p>{command.description}</p></header>
        <div className="command-recovery-body">
            <div className="command-recovery-step"><FiCheck aria-hidden="true" /><span>Only failed orders are checked.</span></div>
            <div className="command-recovery-step"><FiCheck aria-hidden="true" /><span>Confirmed payments update the linked orders.</span></div>
            <label className="command-lookback" htmlFor="command-recovery-hours"><span><FiClock aria-hidden="true" /> Look back period</span>
                <select id="command-recovery-hours" value={hours} onChange={(event) => setHours(Number(event.target.value))} disabled={Boolean(running)}>
                    {[6, 12, 24, 48, 72, 168].map((value) => <option key={value} value={value}>{value === 168 ? '7 days' : `${value} hours`}{value === 48 ? ' (default)' : ''}</option>)}
                </select></label>
            <CommandDetails command={command} visible={showDetails} />
            <button type="button" className="portal-button portal-button-primary command-recovery-run" disabled={Boolean(running)} onClick={(event) => onRun(command, hours, event.currentTarget)}>
                {busy ? <><FiLoader className="command-spin" aria-hidden="true" />Checking orders…</> : <>{command.action}<FiArrowRight aria-hidden="true" /></>}
            </button>
            <RunResult result={result} /><RecoveryResults result={result} />
        </div>
    </section>;
}
